import Vue from 'vue'
import App from './App.vue'

import router from './router/router'
import store from './store/store'

import vuetify from './plugins/vuetify';
import axios from './plugins/axios'

import VueDayjs from 'vue-dayjs-plugin'

Vue.use(VueDayjs)

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from 'v-money'
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  precision: 2,
  masked: false
})
Vue.directive( money )

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: h => h(App)
}).$mount('#app')
